import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';

import { RumComponentContextProvider } from '@mint-lib/datadog';
import { QueryClientProvider } from '@mint-lib/query-client';
import { Outlet } from '@mint/routing';

import { queryClient } from '../api/queries/client.js';
import store from '../redux/store.js';

const IntegrationsApp = () => {
  return (
    <RumComponentContextProvider componentArea="integrations">
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Outlet />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </RumComponentContextProvider>
  );
};

export default IntegrationsApp;
